import { RemPreferences } from "../../api/model";
import Barrel from "../../model/Barrel";
import BarrelType from "../../model/BarrelType";

export function getLinkedStyleguideIds(barrel: Barrel, barrelType: BarrelType) {
    if (barrelType === BarrelType.STYLEGUIDE) {
        return [...barrel.ancestors!].reverse();
    }

    if (!barrel.styleguideLink) {
        return [];
    }

    const { styleguide, status: linkStatus } = barrel.styleguideLink!;
    if (linkStatus === "active") {
        const reversedAncestors = [...styleguide.ancestors!].reverse();
        return [styleguide._id, ...reversedAncestors];
    }

    return [];
}

export function getParentStyleguideToInheritRemPreferences(
    remPreferences: RemPreferences,
    linkedStyleguides: Barrel[]
): Pick<Barrel, "name" | "remPreferences"> | undefined {
    let styleguide;

    if (remPreferences.status && remPreferences.status !== "linked") {
        styleguide = linkedStyleguides.find(
            linkedStyleguide => linkedStyleguide.remPreferences.status && linkedStyleguide.remPreferences.status !== "linked"
        );
    }

    return (
        styleguide && {
            name: styleguide.name,
            remPreferences: styleguide.remPreferences
        }
    );
}
